<template>
  <el-dialog :visible.sync="state" title="修改计划账号" width="402px" :close-on-click-modal="false" :show-close="false">
    <div>
      <div style="margin-bottom: 6px">
        <p style="color: #ff6400; line-height: 22px">
          A、更换账号，系统会将填写的【消耗修改时间】这段时间内的消耗会从原账号转移到更换后的账号内，此时间段外的消耗不会做转移，请务必填写正确的【消耗修改时间】
        </p>
        <span style="color: #ff6400; line-height: 0">B、请不要频繁使用账号更改功能，操作错误会造成财务数据不正确</span>
      </div>
      <el-form label-width="74px">
        <el-form-item label="账号更改">
          <el-select v-model="accountId" placeholder="请选择" :popper-append-to-body="false" filterable clearable style="width: 100%">
            <el-option v-for="item in accountDataFilterMedia" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消耗修改">
          <DateRangePicker v-model="datetime" :append-to-body="false" style="width: 100%"></DateRangePicker>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="m-foot">
        <el-button @click="closeModal">关闭</el-button>
        <el-button type="primary" :loading="loading" @click="update"> 确定 </el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { modifyPlanAccount } from '@/api/track.plan.model'
import DateRangePicker from '@/components/date-range-picker/index.vue'

import { initPageData, AGENTS, MEDIA_ACCOUNTS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([AGENTS, MEDIA_ACCOUNTS])

export default {
  name: 'accountModify',
  components: { DateRangePicker },
  props: {
    value: {
      type: Boolean
    },
    planInfo: {
      type: Object
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    accountDataFilterMedia() {
      return this.MEDIA_ACCOUNTS.filter((ret) => ret.mediaId === this.planInfo.mediaId)
    }
  },
  methods: {
    update() {
      const { planId } = this.planInfo
      const params = {
        planId,
        accountId: this.accountId,
        beginTime: this.datetime[0],
        endTime: this.datetime[1]
      }
      if (!this.accountId || !this.datetime.length) {
        this.$Message.warning('账号选择或消耗修改时间不可为空！')
        return
      }
      modifyPlanAccount(params).then((data) => {
        if (data) {
          this.closeModal()
          this.$Message.success('修改成功')
          this.$emit('on-refresh')
        }
      })
    },
    handleDatetime(val) {
      this.datetime = val
    },
    clearShortCut() {
      const shortCut = document.querySelectorAll('.ivu-picker-panel-shortcut')
      const len = shortCut.length
      for (let i = 0; i < len; i++) {
        shortCut[i].style.background = 'none'
      }
    },
    closeModal() {
      this.$emit('input', false)
      this.datetime = []
      this.accountId = ''
    }
  },
  data() {
    return {
      loading: false,
      accountId: '',
      datetime: []
    }
  },
  created() {}
}
</script>
